import { connect } from 'react-redux';
import { hideModal } from '../actions';
import AboutLimitsModal from './AboutLimitsModal';
import { getModalData } from '../selectors';

const mapDispatchToProps = { onClose: hideModal };
const mapStateToProps = (state) => {
  const { visible } = getModalData(state);
  return ({
    open: visible,
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutLimitsModal);
